export const FDR_LINK = "https://racing.fanduel.com";
export const USGSA_TRACK_SOURCE = "USGSA";

export const viewOptions = {
  ALL: "All Tracks",
  US: "USA",
  INTERNATIONAL: "International",
};

export const HR_DESCRIPTION =
  "Stay up to date with the latest news, information and updates on Horse Racing. Get all the insights on horse racing odds, picks & predictions";

export enum SEO_TRACK {
  CHURCHILL_DOWNS = "Churchill Downs",
  PIMLICO = "Pimlico",
  SARATOGA_RACE_COURSE = "Saratoga Race Course",
  DEL_MAR = "Del Mar",
}

export const SEO_URL = {
  [SEO_TRACK.CHURCHILL_DOWNS]: {
    ODDS: "https://www.fanduel.com/kentucky-derby-odds",
    BETTING: "https://www.fanduel.com/kentucky-derby-betting",
    CONTENDERS: "https://www.fanduel.com/kentucky-derby-contenders",
  },
  [SEO_TRACK.PIMLICO]: {
    ODDS: "https://www.fanduel.com/preakness-stakes-odds",
    BETTING: "https://www.fanduel.com/preakness-stakes-betting",
  },
  [SEO_TRACK.SARATOGA_RACE_COURSE]: {
    ODDS: "https://www.fanduel.com/belmont-stakes-odds",
    BETTING: "https://www.fanduel.com/belmont-stakes-betting",
  },
  [SEO_TRACK.DEL_MAR]: {
    ODDS: "https://www.fanduel.com/breeders-cup-odds",
    BETTING: "https://www.fanduel.com/breeders-cup-betting",
  },
};
